var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clearfix"},[_c('h2',{staticClass:"float-left mb-3 filters-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"filters float-right"},[_vm._t("filters")],2)]),_c('br'),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }